/* eslint-disable @typescript-eslint/no-explicit-any */
import { IWithContextProps, core, withContext } from '@tock/coretypes';
import { RouteComponentProps } from 'react-router-dom';

import { IntlProvider } from 'react-intl';
import BaseComponent from '@tock/shared/components/BaseComponent';
import PartnerBookingsDropdown from 'components/account/PartnerBookingsDropdown';
import ReservationHistory from 'components/profile/reservations/ReservationHistory';
import connect, { DefaultConnectProps, StoreType } from '@tock/shared/utils/connect';

interface ConnectProps extends DefaultConnectProps {
  patron: StoreType['patron'];
}

type Props = RouteComponentProps<any> & ConnectProps & IWithContextProps;

const TOCK_PARTNER = 59;

class ProfileReservationsRoute extends BaseComponent<Props> {
  componentDidMount() {
    const { actions } = this.props;
    actions.navigation.set({
      title: 'Reservations',
    });
    actions.transfer.clearTransferSelection();
  }

  handleChangeBookings(option: SelectOption) {
    this.props.history.push(`/profile/${option.value}`);
  }

  handleDirectToReservationPage(path: string) {
    this.props.history.push(path);
  }

  render() {
    const {
      app: { patron, settings, activePartnerRole },
    } = this.props;

    if (!settings) {
      return null;
    }

    return (
      <IntlProvider locale={settings.USER_LOCALE}>
        <div className="SectionWrapper--medium SectionWrapper">
          <div className="SectionContent">
            {activePartnerRole && activePartnerRole.partner?.id !== TOCK_PARTNER && (
              <div className="Reservations-dropdownContainer">
                <PartnerBookingsDropdown
                  partnerName={activePartnerRole.partner?.name || undefined}
                  onChangeBookings={this.handleChangeBookings}
                />
              </div>
            )}
            <ReservationHistory patron={patron as core.IPatron} />
          </div>
        </div>
      </IntlProvider>
    );
  }
}

export default connect<RouteComponentProps<any>, ConnectProps>(
  withContext(ProfileReservationsRoute),
  (state: StoreType) => {
    return {
      patron: state.patron,
    };
  }
);
